import find from 'lodash/find'

export const mapStateToPlaceOrderDetails = (state) => {
  const entities = state.entities;
  const shippingAddress = find(entities.Addresses, a => a.Id === entities.SelectedShippingAddressId);
  const billingAddress = (state.ui.useShippingForBilling)
    ? shippingAddress
    : find(entities.Addresses,
        address =>
          address.Id === entities.SelectedBillingAddressId
          && entities.BillingAddresses.includes(address.Id));
  const shippingOption = entities.ShippingOptions.filter(so => so.Id === entities.SelectedShippingOptionId)[0];
  return {
    SelectedPayment: {
      Id: entities.SelectedPaymentOptionId,
      POValue: entities.PaymentRecord.POValue ?? null,
      BraintreePaymentNonce: entities.PaymentRecord.BraintreePaymentNonce ?? null
    },

    SelectedShippingAddress: shippingAddress,
    SelectedBillingAddress: billingAddress,
    SelectedShippingOption: shippingOption,
    Coupons: state.entities.Coupons,
    BillingEqualsShipping: state.ui.useShippingForBilling,
    Total: state.entities.Summary.Total,
    PartnerIds: state.entities.Coupons.length > 0 ? state.entities.Coupons.filter(c => c.IsPartnerIdDiscount && c.Description).map(c => c.Description) : null,
    TermsAndConditions: state.ui.termsAndConditions,  
    IsPartnerIdRequired: state.entities.CartItems.some(item => item.RequiresPartnerId),
    IsShippingRequired: state.entities.CartItems.some(item => item.IsPhysical),
    IsTermsAndConditionsRequired: state.entities.CartItems.some(item => item.IsLicense),
      RequiredPartnerIds: state.entities.RequiredPartnerIds,
      IsStopWorkShop: state.entities.CartItems.some(item => item.IsStopWorkShop),
  };
}
